import { render, staticRenderFns } from "./TaskItemAmounts.component.vue?vue&type=template&id=429c9f9a&scoped=true&"
import script from "./TaskItemAmounts.component.vue?vue&type=script&lang=js&"
export * from "./TaskItemAmounts.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429c9f9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
